<template>
  <div>404 PageNotFound</div>
</template>

<script>
export default {
    name: "PageNotFound"
}
</script>

<style>

</style>